import React, {useEffect} from 'react';
import {BuyerNote} from '../../../../../common/components/BuyerNote/BuyerNote';
import {CartItems} from '../../../../../common/components/CartItems/CartItems';
import {useControllerProps} from '../../../../../domain/controllers/ControllerContext';
import s from './CartBody.scss';
import {CartScreenReaderMessage} from './CartScreenReaderMessage/CartScreenReaderMessage';
import {Coupon} from '../../../../../common/components/Coupon/Coupon';
import settingsParams from '../../../settingsParams';

export enum CartBodyDataHook {
  CartAsideLoader = 'CartBody.aside',
  CartAsideContent = 'CartBody.content',
}

export const CartBody = () => {
  const {shouldShowCoupon, shouldShowBuyerNote, reportBuyerNotePresented, reportPromoCodePresented} =
    useControllerProps().cartStore;

  useEffect(() => {
    reportPromoCodePresented(shouldShowCoupon);
    reportBuyerNotePresented(shouldShowBuyerNote);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldShowCoupon, shouldShowBuyerNote]);

  return (
    <>
      <CartItems showQuantityBySettings showThumbnailBySettings shouldShowItemInfoBySettings />
      <footer className={s.footer}>
        {shouldShowCoupon && (
          <div className={s.coupon}>
            <Coupon
              textButtonSettingKey={settingsParams.CART_ADD_PROMO_CODE_LINK}
              applyButtonTranslationKey={'cart.coupon_apply_button_label'}
              placeholderTranslationKey={'cart.coupon_input_placeholder'}
            />
          </div>
        )}
        {shouldShowBuyerNote && (
          <div className={s.buyerNote}>
            <BuyerNote
              buttonCaptionSettingKey={settingsParams.CART_ADD_NOTE_LINK}
              buttonPlaceholderSettingKey={settingsParams.CART_INSTRUCTIONS_TEXT}
            />
          </div>
        )}
      </footer>
      <CartScreenReaderMessage />
    </>
  );
};
